module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//modal-custom-top1.png?v=5c7601bc";